import React from "react";
import PropTypes from "prop-types";
import { TabContent,NoDataDiv } from "./styles";
import { Row, Divider } from "antd";
import { NoData } from "../commonStyles";

function TabPaneCard(props) {
  const {
    tabComponent,
    tabIndex,
    filters,
    length,
    text,
    tabConfig,
    itemData,
    columnConfig,
    expandConfig,
    findExpanded,
    clicked,
    getPageTitle,
    exportDataUpdate
  } = props; 
  
  switch (tabComponent) {
    case 'card':
      if (length === 0) {
        return (
          <TabContent>
            <NoDataDiv>
              <NoData>{text}</NoData>
            </NoDataDiv>
          </TabContent>
        );
      } else {
        return itemData.map((item, dataIndex) => {
          let configOfTab = tabConfig(item, dataIndex, () => clicked(item));
          return (
            <>
              <TabContent>
                <Row index={dataIndex} className='px3 py2'>
                  {configOfTab[tabIndex].config.map(item => item.render)}
                </Row>
              </TabContent>
              <Divider
                className={
                  dataIndex === length - 1 ? 'display-none' : 'mx3 my0 w94'
                }
              />
            </>
          );
        });
      }
    case "table":
      let configOfTabs = tabConfig(
        itemData,
        columnConfig,
        expandConfig,
        filters,
        findExpanded,
        getPageTitle,
        exportDataUpdate
      );     

      return (
        <>
          <TabContent>
            {length === 0 ? (
              <NoDataDiv>
                <NoData>{text}</NoData>
              </NoDataDiv>
            ) : (
              <Row>                
              {configOfTabs[tabIndex].render}
              </Row>
            )}
          </TabContent>
        </>
      );
    default:
      return "Not passed component type";
  }
}

TabPaneCard.propTypes = {
  clicked: PropTypes.func,
  columnConfig: PropTypes.array,
  expandConfig: PropTypes.any,
  filters: PropTypes.any,
  findExpanded: PropTypes.any,
  getPageTitle: PropTypes.any,
  itemData: PropTypes.array,
  length: PropTypes.number,
  tabComponent: PropTypes.string,
  tabConfig: PropTypes.any,
  tabIndex:  PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  text: PropTypes.string
}

export default TabPaneCard;
